import { TFunction } from 'i18next';

export const getStatusOptions = (t: TFunction) => ({
  AC: t('requestStatusName.AC'),
  CA: t('requestStatusName.CA'),
  CL: t('requestStatusName.CL'),
  IP: t('requestStatusName.IP'),
  NR: t('requestStatusName.NR'),
  OH: t('requestStatusName.OH')
});

export const getCancellationReasonOptions = (t: TFunction) => ({
  A: t('requestHistory.cancellationReason.A'),
  L: t('requestHistory.cancellationReason.L'),
  S: t('requestHistory.cancellationReason.S'),
  E: t('requestHistory.cancellationReason.E'),
  O: t('requestHistory.cancellationReason.O')
});
